export default function (val) {
    return val === '1' || val === 'true' || val === 'yes' || val === 'on';
}